import { render, staticRenderFns } from "./CreateShowItem.vue?vue&type=template&id=1d5f1260&scoped=true&"
import script from "./CreateShowItem.vue?vue&type=script&lang=js&"
export * from "./CreateShowItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateShowItem.vue?vue&type=style&index=0&id=1d5f1260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f1260",
  null
  
)

export default component.exports